import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CountOutputData } from "../../../../../utils/count-calculator/count-calculator.model";
import { ColorsPicker } from "~/src/utils/color-constants";

@Component({
    selector: "get-count",
    templateUrl: "./get-count.component.html",
    styleUrls: ["./get-count.component.scss"],
    standalone: false,
})
export class GetCountComponent implements OnInit {
    public displayedColumns = ["name", "facePattern", "color", "count", "connectionDetails"];
    public dataSource!: CountOutputData[];
    public isLoading = true;

    constructor(@Inject(MAT_DIALOG_DATA) public data: CountOutputData[]) {}

    ngOnInit(): void {
        if (this.data) {
            this.isLoading = false;
            this.dataSource = this.data;
        }
    }

    public getFaceColors(colorObject: object | undefined): { key: string; value: string }[] {
        if (!colorObject) {
            return [];
        }
        return Object.entries(colorObject).map(([key, value]) => {
            const colorValue = `${(value as string).toUpperCase()}`; // Normalize color value
            const color = ColorsPicker.find((c) => c.value.toUpperCase() === colorValue);
            return {
                key,
                value: color ? color.name : "Unknown Color",
            };
        });
    }

    closeDialogBox() {}
}

export interface PeriodicElement {
    name: string;
    facePattern: string;
    count: number;
    color: string;
}
